import React, { useEffect, useState } from 'react'
import { Box, Flex, Link } from 'rebass/styled-components'
import SwiperLoader from '../loaders/SwiperLoader'
import styled from 'styled-components'
import MediaRender from '../general/MediaRender'
import SwiperRender from './SwiperRender'

const Container = styled(Box)`
ul {
    padding: 0;
    list-style: none;
    margin-top: 0;
    margin-left: auto;
    margin-bottom: 40px;
    margin-right: auto;

    li {
        background-color: ${(props) => props.theme.colors.black};
        overflow: hidden;
        height: 210px;
        width: 210px;
    }
        
    a {
        color: ${(props) => props.theme.colors.white};
        display: block;
        height: 100%;
        overflow: hidden;
        position: relative;
        text-decoration: none;

        .media {
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            display: block;
            height: 100%;
        }
        .textAlternative {
            background-color: rgba(0, 0, 0, 0.75);
            display: block;
            font-size: ${(props) => props.theme.fontSizes.xs};
            left: 0;
            /* opacity: 0.5; */
            line-height: ${(props) => props.theme.fontSizes.md};
            min-height: 50%;
            padding: ${(props) => props.theme.space[2]};
            position: absolute;
            top: 0;
            transform: translateY(-100%);
            transition-duration: 300ms;
            transition-property: transform;
            transition-timing-function: cubic-bezier(0.7, -0.5, 0.1, 1);
            width: 100%;
            will-change: transform;
        }

        &:hover .textAlternative {
            /* opacity: 1.0; */
            transform: translateY(0);
        }
    }
}
`

const SwiperInstagram = ({ slides }) => {
    const [slidesCompiled, setSlides] = useState([])
    const truncate = function(string, maxLength = 200) {
        if (string && string.length > maxLength) {
            return string.substring(0, maxLength) + '...';
        } else {
            return string
        }
    }
    useEffect(() => {
        if (slides.length && !slidesCompiled.length) {
            const slidesArray = []
            Object.entries(slides).map(([key, slide]) => {
                const { caption } = slide
                const useCaption = (caption !== '') ? true : false
                slidesArray.push(
                    <Link key={slide.id} target="_blank" href={slide.permalink}>
                        <MediaRender file={{
                            type: 'static',
                            filepath: slide.media_url,
                            media_type: 'image',
                        }} options={{ backgroundVideo: true, backgroundImage: true }} alt="" classes='media swiper-lazy' />
                        {useCaption && caption ? <Box as="span" className="textAlternative">{truncate(caption, 120)}</Box> : null}
                        <SwiperLoader />
                    </Link>,
                )
                return true
            })
            setSlides(slidesArray)
        }
    }, [slides, slidesCompiled])

    const navigationMarkup = (
        <Box
            pl="md"
            pr="md"
        >
            <Box
                className="swiper-scrollbar"
                height='26px'
                variant='container'
                width="100%"
                sx={{
                    position: 'relative',
                    background: 'transparent !important',
                }}>
                <Flex
                    alignItems="center"
                    className="swiper-scrollbar-drag"
                    height="100%"
                    width="4px"
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                    }}>
                    <Box
                        bg="aquaDark"
                        height="100%"
                        width="4px" />
                </Flex>
                <Box
                    bg="aquaLight"
                    height="4px"
                    width='100%'
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: 'calc(50% - 2px)',
                    }}></Box>
            </Box>
        </Box>
    )

    return (
        slidesCompiled.length ? (
            <Container>
                <SwiperRender options={{
                    allowTouchMove: true,
                    direction: 'horizontal',
                    followFinger: true,
                    grabCursor: true,
                    longSwipes: true,
                    slidesPerView: 'auto',
                    tag: 'section',
                    mousewheel: {
                        forceToAxis: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    wrapperTag: 'ul',
                    slideTag: 'li',
                    lazy: {
                        checkInView: true,
                        loadOnTransitionStart: true,
                        loadPrevNext: true,
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        dragSize: 60,
                        hide: false,
                        snapOnRelease: true,
                        dragSize: '4px',
                    },
                    slides: slidesCompiled,
                    navigationMarkup,
                }} />
            </Container>
        ) : null
    )
}

export default SwiperInstagram
